import React, { FC, useContext } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Stack } from '../stack/Stack';
import { Typography } from '../typography/Typography';
import { formatForID } from '../../utils';

// Interface

export interface TitleBlockProps {
  heading: string;
  subHeading?: string;
  centered?: boolean;
  style?: 'primary' | 'secondary'; // Select
}

export interface StyledTitleBlockProps {
  centered?: boolean;
}

export const StyledTitleBlock = styled(Stack)<StyledTitleBlockProps>`
  ${({ theme: { media }, centered }) => css`
    text-align: ${centered ? 'center' : 'left'};

    @media (min-width: ${media.medium}) {
      margin-left: ${centered ? 'auto' : '0'};
      margin-right: ${centered ? 'auto' : '0'};

      h2,
      p {
        text-wrap: balance;
      }
    }
  `}
`;

// JSX

export const TitleBlock: FC<TitleBlockProps> = ({
  heading,
  subHeading,
  centered,
  style = 'primary',
}) => {
  const titleStyle = style?.charAt(0).toUpperCase() + style?.slice(1);

  const headingComponent = titleStyle === 'Secondary' ? 'h3' : 'h2';

  const getHeadingVariant = () => {
    if (titleStyle === 'Impact') {
      return 'headingLarge';
    }
    if (titleStyle === 'Secondary') {
      return 'headingSmall';
    }
    return 'headingMedium';
  };

  return (
    <StyledTitleBlock gap="small" centered={centered} id={heading? formatForID(heading) : ''}>
      <Typography component={headingComponent} variant={getHeadingVariant()}>
        {heading}
      </Typography>
      {subHeading && (
        <Typography component="p" variant="secondaryHeadingSmall">
          {subHeading}
        </Typography>
      )}
    </StyledTitleBlock>
  );
};

export default TitleBlock;
